import { Form, Formik } from "formik";
import React, { useContext, useEffect, useRef, useState } from "react";
import { getApi, postApi } from "../../services/api/globalApi";
import TicketMessage from "../../components/tickets/ticket-message/TicketMessage";
import Input from "../../components/common/inputs/Input";
import { useParams } from "react-router";
import { motion } from "framer-motion";
import { convertDate } from "../../utils/convertDate";
import { Link } from "react-router-dom";
import UploadFileList from "../../components/tickets/upload-file-list/UploadFileList";
import { errorMessage } from "../../utils/toastify-message/ToastifyMessage";
import Button from "../../components/common/button/Button";
import { messageValidte } from "../../components/common/validations/messageValidte";
import TicketStatusModal from "../../components/tickets/ticket-status-modal/TicketStatusModal";
import { context } from "../../context/context";

function TicketsInfo() {
  const params = useParams();
  const { utils } = useContext(context);

  const [ticketData, setTicketData] = useState(null);
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const getTicket = async () => {
    const path = `tickets/${params?.id}`;
    try {
      const response = await getApi({ path });
      setTicketData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTicket();
  }, []);

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const path = "filemanagers";

    try {
      const response = await postApi({
        path,
        body: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response?.data?.data?.data;
    } catch (error) {
      console.error("خطا در آپلود فایل:", error);
      return null;
    }
  };

  const sendMessage = async (values, { resetForm }) => {
    const path = `tickets/${params?.id}/message`;
    setIsUploading(true);
    const uploadedFileUrls = await Promise.all(
      files.map((file) => uploadFile(file))
    );

    const validFileUrls = uploadedFileUrls.filter((url) => url !== null);

    const body = {
      ...values,
      files: validFileUrls,
    };
    try {
      await postApi({ path, body });
      setIsUploading(false);
      resetForm();
      setFiles([]);
      getTicket();
    } catch (error) {
      setIsUploading(false);
      errorMessage(error?.response?.data?.errors[0]?.message);
      console.log(error);
    }
  };

  const handleFileChange = (e) => {
    const { files: selectedFiles } = e.target;
    const maxFileSize = 2 * 1024 * 1024; // 2MB
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

    const validFiles = Array.from(selectedFiles).filter((file) => {
      if (file.size > maxFileSize) {
        errorMessage("فایل انتخابی نباید بیشتر از 2 مگابایت باشد.");
        return false;
      }
      if (!allowedTypes.includes(file.type)) {
        errorMessage("فایل انتخابی باید فرمت jpg، png یا pdf داشته باشد.");
        return false;
      }
      return true;
    });

    if (validFiles.length > 0) {
      setFiles((prev) => [...prev, ...validFiles]);
    }
  };

  const deleteFile = (index) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  const statusRef = useRef();

  return (
    <>
      <TicketStatusModal
        ref={statusRef}
        data={ticketData}
        reGetData={getTicket}
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.5,
          // ease: [0, 0.71, 0.2, 1.01]
        }}
        className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
      >
        <div className="flex items-center justify-between">
          <h2 class="text-xl font-semibold mb-2 text-gray-800 dark:text-white"> {ticketData?.title}</h2>
          <div className="flex gap-2 cursor-pointer text-gray-800 dark:text-white">
            <span onClick={() => statusRef?.current?.showModal()}>
              تغییر وضعیت
            </span>
            <Link to={"/ticket-list"}>بازگشت</Link>
          </div>
        </div>
        <h3 class="text-lg mb-2 text-gray-700 dark:text-gray-100">کاربر {ticketData?.user?.name}</h3>

        <div class="flex flex-wrap items-center gap-4 my-4 pb-6 border-b border-gray-100 dark:border-gray-600">
          <span class="text-white text-sm bg-blue-400 rounded-md py-1.5 px-3">
            تاریخ ثبت: {convertDate(ticketData?.createdAt, false)}
          </span>
          <span class="text-white text-sm bg-blue-400 rounded-md py-1.5 px-3">
            وضعیت:{" "}
            {ticketData?.status == utils?.TIECKET_STATUS?.open?.value
              ? "باز"
              : "بسته شده"}
          </span>
          <span class="text-white text-sm bg-blue-400 rounded-md py-1.5 px-3">
            بخش مربوطه: {utils?.TICKET_DEPARTMENTS?.[ticketData?.department]?.name }
          </span>
        </div>
        <div className="flex flex-col gap-6 w-full mt-6">
          {ticketData?.messages?.length
            ? ticketData?.messages.map((item) => {
                return <TicketMessage data={item} />;
              })
            : null}
        </div>
        <div className="p-4">
          <Formik
            enableReinitialize
            initialValues={{
              message: "",
            }}
            validationSchema={messageValidte}
            onSubmit={sendMessage}
          >
            {() => (
              <Form>
                <div className="flex gap-4 w-full">
                  <Input
                    containerClass={"w-full"}
                    name="message"
                    placeholder="متن پیام"
                    type="text"
                  />

                  <label
                    className="px-4 h-10 text-white mt-2 flex items-center bg-green-500 transition-all hover:bg-green-600 cursor-pointer rounded-md"
                    htmlFor="fileInput"
                  >
                    فایل
                  </label>
                  <input
                    disabled={isUploading}
                    accept=".pdf, .png, .jpg,.jpeg"
                    multiple
                    onChange={handleFileChange}
                    className="hidden"
                    id="fileInput"
                    type="file"
                  />
                  <Button
                    disabled={isUploading}
                    className={`${files?.length ? "!w-64" : ""} mt-2`}
                    text={files?.length ? "ارسال و آپلود فایل" : "ارسال"}
                    color="primary"
                  />
                </div>
              </Form>
            )}
          </Formik>
          <UploadFileList
            files={files}
            deleteFile={deleteFile}
            isUploading={isUploading}
          />
        </div>
      </motion.div>
    </>
  );
}

export default TicketsInfo;
